import { createAsyncThunk } from '@reduxjs/toolkit';

import { GlobalCatalogItem } from 'entities/CatalogItem';
import { ExtendedAxiosRequestConfig } from 'shared/api/types';
import { ResponseWithPagination } from 'shared/types/responses';

import { FETCH_ABORTED } from '../../consts/catalogItemsConsts';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

interface GlobalCatalogItemsRequestData {
    searchString?: string;
    categoryId?: string;
    abortController?: AbortController;
}

export const fetchGlobalCatalogItems = createAsyncThunk<
    ResponseWithPagination<GlobalCatalogItem[]>,
    GlobalCatalogItemsRequestData,
    ThunkConfig<string>
>(
    'catalogItem/fetchGlobalCatalogItem',
    async ({ searchString, categoryId, abortController }, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;

        // if (!searchString) return;

        try {
            const config: ExtendedAxiosRequestConfig = {
                signal: abortController?.signal,
                params: { searchString, categoryId },
                keysToNotConvert: ['specifications'],
            };

            const response = await extra.api.get<
                ResponseWithPagination<GlobalCatalogItem[]>
            >(`/v1/catalogs/search-items`, config);

            return response.data;
        } catch (e) {
            const isAborted =
                (e as { code?: string })?.code === 'ERR_CANCELED' ||
                (e as { name?: string })?.name === 'AbortError';
            if (isAborted) {
                return rejectWithValue(FETCH_ABORTED);
            }
            return rejectWithValue('error');
        }
    },
);
